// SPDX-License-Identifier: AGPL-3.0-or-later

/**
 * Whether an effect that last fired at `lastAt` may fire again at `now`.
 *
 * Every holiday effect keeps its own timestamp — there is no shared clock, because effects fire on
 * unrelated triggers and should not block each other. This only shares the comparison, so the
 * direction of the inequality is written once.
 */
export function cooldownElapsed(lastAt: number | null | undefined, now: number, cooldownMs: number): boolean {
	if (lastAt == null) return true;
	return now >= lastAt + cooldownMs;
}
